import { render, staticRenderFns } from "./divisionList.vue?vue&type=template&id=06d5f8f5&scoped=true&"
import script from "./divisionList.vue?vue&type=script&lang=js&"
export * from "./divisionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d5f8f5",
  null
  
)

export default component.exports